import React from 'react';
import { Spinner } from '@acorns/web-components';
import { compose, withContext, getContext, branch, renderComponent } from 'recompose';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import IsAuthenticatedQuery from '../IsAuthenticated.gql';
import { ChildrenOnly } from '../../ChildrenOnly';
var style = {
  height: '100vh',
  width: '100vw',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

var CenteredSpinner = function CenteredSpinner() {
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/React.createElement(Spinner, null));
};

var AuthPropTypes = {
  auth: PropTypes.shape({
    isAccountClosed: PropTypes.bool.isRequired,
    isUserRegComplete: PropTypes.bool.isRequired,
    isUserLoggedIn: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    uuid: PropTypes.string.isRequired,
    error: PropTypes.any
  }).isRequired
};
var Provider = compose(graphql(IsAuthenticatedQuery, {
  options: {
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all'
  }
}), branch(function (_ref) {
  var data = _ref.data;

  if (process.env.BUILD_ENV !== 'production') {
    console.log('If your app is infinitely loading or crashing, you might need to log in first!');
  }

  return data.loading;
}, renderComponent(CenteredSpinner)), withContext(AuthPropTypes, function (_ref2) {
  var _data$user, _data$user2, _data$user3, _data$user4;

  var data = _ref2.data;
  return {
    auth: {
      error: data === null || data === void 0 ? void 0 : data.error,
      isAccountClosed: !!(data === null || data === void 0 ? void 0 : (_data$user = data.user) === null || _data$user === void 0 ? void 0 : _data$user.closedAt),
      isUserLoggedIn: !!(data === null || data === void 0 ? void 0 : (_data$user2 = data.user) === null || _data$user2 === void 0 ? void 0 : _data$user2.uuid),
      isUserRegComplete: !!(data === null || data === void 0 ? void 0 : (_data$user3 = data.user) === null || _data$user3 === void 0 ? void 0 : _data$user3.registrationComplete),
      isLoading: data.loading,
      uuid: data === null || data === void 0 ? void 0 : (_data$user4 = data.user) === null || _data$user4 === void 0 ? void 0 : _data$user4.uuid
    }
  };
}));
var AuthRecomposeProvider = Provider(ChildrenOnly);
var withAuth = getContext(AuthPropTypes);
export { AuthRecomposeProvider, withAuth };